import React from 'react';
import { useRevalidator, useParams, Link, redirect } from 'react-router-dom';
import WarningMessage from '../../components/warning_message/warning_message';
import { AuthProvider } from '../../auth_provider';
import { DESKTOP_PATH } from '../../constants/paths';
import './login.scss';

import logoDecoration from '../../images/login_side_decoration.png';
import odontoSecureText from '../../images/odonto_secure_text.png';


export async function loginLoader() {
  if (!AuthProvider.is_authenticated) {
    await AuthProvider.isAuthenticated();
  }

  if (AuthProvider.is_authenticated) {
    return redirect(AuthProvider.redirect_to || DESKTOP_PATH);
  }

  return true;
};

function LoginInput(props) {
  return (
    <div className="login__input-wrapper">

      <label 
        className="login__input__label"
        htmlFor={`default_input_${props.name}`}
      >
        {props.label}
      </label>

      <input
        id={`default_input_${props.name}`}
        className="login__input"
        name={props.name}
        type={props.type}
        placeholder={props.placeholder}
        onChange={(event) => props.onChange(event)}
        value={props.value}
        onKeyDown={(event) => props.onKeyDown(event)}
        autoComplete={props.autoComplete}
        disabled={props.disabled}
      />

    </div>
  );
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      passwordConfirmation: "",
      passwordUpdated:false,
      invalidHash: false,
      authenticating: false,
      warningMessage: "",
      showWarningMessage: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isRecoveryPath !== prevProps.isRecoveryPath) {
      this.setState({
        showWarningMessage: false,
        passwordUpdated: false,
        invalidHash: false,
        authenticating: false,
        warningMessage: "",
        password: "",
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  mayAuthenticate() {
    return this.state.email.match(/.+@.+\..+/) != null &&
           this.state.password.length > 0;
  }

  handleKeyDown(event) {
    if (this.props.isRecoveryPath) {
      if(event.keyCode === 13 && this.passwordRecoveryInputsAreValid()) {
        this.updatePasssword();
      }
    }
    else {
      if(event.keyCode === 13 && this.mayAuthenticate()) {
        this.authenticate();
      }
    }
  }

  async handleAuthenticateError(response) {
    if(response.status === 401) {
      const data = await response.json();

      if(data.code === 202) {
        this.setState({
          authenticating: false,
          showWarningMessage: true,
          warningMessage: "E-mail ou(e) senha inválido(s). Tente novamente.",
          password: "",
        });

        return null;
      }
    }
    else if(response.status === 403) {
      const data = await response.json();

      if(data.code === 203) {
        if(data.message.includes('User disabled')) {
          this.setState({
            authenticating: false,
            showWarningMessage: true,
            warningMessage: "Usuário desabilitado. Por favor, entre em contato com o responsável pela unidade.",
            password: "",
          });
        }
        else {
          this.setState({
            authenticating: false,
            showWarningMessage: true,
            warningMessage: "Usuário não possui permissão",
            password: "",
          });
        }

        return null;
      }
    }

    throw Error('Infelizmente estamos com problemas em nosso serviço. Por favor, tente novamente mais tarde.');
  }

  async handlePasswordrecoveryError(response) {
    if(response.status === 401) {
      const data = await response.json();

      if(data.code === 202) {
        this.setState({
          authenticating: false,
          invalidHash: true,
          showWarningMessage: true,
          warningMessage: "Link de redefinição de senha inválido.",
          password: "",
          passwordConfirmation: "",
        });

        return null;
      }
    }
    else if(response.status === 403) {
      const data = await response.json();

      if(data.code === 203) {
        this.setState({
          authenticating: false,
          invalidHash: true,
          showWarningMessage: true,
          warningMessage: "Link de redefinição de senha inválido.",
          password: "",
          passwordConfirmation: "",
        });

        return null;
      }
    }

    throw Error('Infelizmente estamos com problemas em nosso serviço. Por favor, tente novamente mais tarde.');
  }

  async authenticate() {
    this.setState({
      authenticating: true,
      showWarningMessage: false,
    });

    const authData = await AuthProvider.authenticate(this.state.email, this.state.password);

    if (!authData) {
      this.setState({
        authenticating: false,
        showWarningMessage: true,
        warningMessage: "Infelizmente estamos com problemas em nosso serviço. Por favor, tente novamente mais tarde.",
      });

      return;
    }

    if (authData.requestFailed) {
      return await this.handleAuthenticateError(authData.response);
    }
    
    this.props.revalidator.revalidate();
  }

  async updatePasssword() {
    const password = this.state.password.trim();
    const passwordConfirmation = this.state.passwordConfirmation.trim();

    if(password !== passwordConfirmation) {
      this.setState({
        showWarningMessage: true,
        warningMessage: "Confirmação de senha inválida. Por favor, digite novamente sua nova senha.",
        password: "",
        passwordConfirmation: "",
      });

      return null;
    }

    this.setState({
      authenticating: true,
      showWarningMessage: false,
    });

    const authData = await AuthProvider.recoverPassword(this.state.password, this.props.params.authHash);

    if (!authData) {
      this.setState({
        authenticating: false,
        showWarningMessage: true,
        warningMessage: "Infelizmente estamos com problemas em nosso serviço. Por favor, tente novamente mais tarde.",
      });

      return;
    }

    if (authData.requestFailed) {
      return await this.handlePasswordrecoveryError(authData.response);
    }    

    this.setState({
      passwordUpdated: true,
      showWarningMessage: true,
      warningMessage: "Senha atualizada com sucesso.",
    });
  }

  passwordRecoveryInputsAreValid() {
    return this.state.password.length > 0 &&
           this.state.passwordConfirmation.length > 0;
  }

  getInputs() {
    if (this.props.isRecoveryPath) {
      if (this.state.passwordUpdated || this.state.invalidHash) {
        return null;
      }
      
      return (
        <>
        
          <form className="login__form">
          
            <LoginInput 
              label="Nova senha"
              name="password"
              type="password"
              placeholder="Nova senha"
              onChange={(event) => this.handleInputChange(event)}
              value={this.state.password}
              onKeyDown={(event) => this.handleKeyDown(event)}
              autoComplete='new-password'
              disabled={this.state.authenticating}
            />

            <LoginInput 
              label="Confirmar senha"
              name="passwordConfirmation"
              type="password"
              placeholder="Confirmar nova senha"
              onChange={(event) => this.handleInputChange(event)}
              value={this.state.passwordConfirmation}
              onKeyDown={(event) => this.handleKeyDown(event)}
              autoComplete='new-password'
              disabled={this.state.authenticating}
            />
  
          </form>
  
          <div className="login__authenticate-wrapper">

            <button
              className="login__authenticate-button"
              disabled={!this.passwordRecoveryInputsAreValid() || this.state.authenticating}
              onClick={() => this.updatePasssword()}
            >

              <i className="fas fa-key"></i>
              {this.state.authenticating ? ' Redefinindo...' : ' Redefinir senha'}

            </button>
  
          </div>
  
        </>
      );
    }

    return (
      <>
      
        <form className="login__form">

          <LoginInput 
            label="E-mail"
            name="email"
            type="email"
            placeholder="Digite seu e-mail"
            onChange={(event) => this.handleInputChange(event)}
            value={this.state.email}
            onKeyDown={(event) => this.handleKeyDown(event)}
            autoComplete='username'
            disabled={this.state.authenticating}
          />

          <LoginInput 
            label="Senha"
            name="password"
            type="password"
            placeholder="Digite sua senha"
            onChange={(event) => this.handleInputChange(event)}
            value={this.state.password}
            onKeyDown={(event) => this.handleKeyDown(event)}
            autoComplete='current-password'
            disabled={this.state.authenticating}
          />

        </form>

        <div className="login__authenticate-wrapper">

        <button
          className="login__authenticate-button"
          disabled={!this.mayAuthenticate() || this.state.authenticating}
          onClick={() => this.authenticate()}
        >

          {this.mayAuthenticate() ? (<i className="fas fa-unlock"></i>) : (<i className="fas fa-lock"></i>)}
          {this.state.authenticating ? ' Entrando...' : ' Entrar'}

        </button>

        </div>

      </>
    );
  }

  render() {
    return (
      <section className="login">

        <div className="login__container">

          <div className="login__main-wrapper">

            <Link
              className="login__main-link"
              to="/"
            >

              <header className="login__header">

                {/* <h1 className="login__header__text">ODONTO SECURE</h1> */}
                <img className="login__header__text-image" src={odontoSecureText} alt="Odonto Secure" />

              </header>

            </Link>

            {(this.props.isRecoveryPath && !this.state.passwordUpdated && !this.state.invalidHash) &&
              <div className="login__title">

                <p className="login__title__text">
                  Digite sua nova senha nos campos abaixo:
                </p>

              </div>
            }

            <WarningMessage
              className="login__warning-message"
              message={this.state.warningMessage}
              onClose={() => {this.setState({showWarningMessage: false})}}
              visible={this.state.showWarningMessage}
              background={(this.props.isRecoveryPath && this.state.passwordUpdated) ? '#9dbea7' : null}
              color={(this.props.isRecoveryPath && this.state.passwordUpdated) ? '#f9f9f9' : null}
              visibleMarginBottom={(this.props.isRecoveryPath && (this.state.passwordUpdated || this.state.invalidHash)) ? '10px' : null}
            />

            {this.getInputs()}

            <footer className="login__footer">

              <p className="login__footer__text">

                <i className="far fa-copyright"></i>
                {' '}{(new Date()).getFullYear()} | ODONTO SECURE

              </p>

            </footer>

          </div>

          <div className="login__side-decorator__wrapper">

            <img className="login__side-decorator" src={logoDecoration} alt="" />

          </div>

        </div>

      </section>
    );
  }
};

const WrappedLogin = props => {
  let revalidator = useRevalidator();
  let params = useParams();

  return (
    <Login
      revalidator={revalidator}
      params={params}
      {...props}
    />
  );
};

export {WrappedLogin as Login};
